
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institutions/[filp]",
      function () {
        return require("private-next-pages/institutions/[filp].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institutions/[filp]"])
      });
    }
  